export const SITE_URL = 'https://sugargoospreadsheet.link';

export const MAIN_SITE_URL = 'https://kaspreadsheet.com/';